import React, { Component } from 'react';
import { render } from 'react-dom';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom'
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import Layout from './components/Layout';
import {saveState, loadState} from './store/localStorage';
import throttle from 'lodash/throttle';


class App extends Component {
	render() {
		// you can re-hydrate initial state here by passing a state object to configure store
		// lets say you store a user object in localstorage. Pluck and place below.
		const persistedState = loadState();
		const store = configureStore(persistedState);
		store.subscribe(throttle(() => {
			saveState({
				mandatories: store.getState().mandatories,
				estimates: store.getState().estimates
			});
		}, 1000));
												
    return (
      <Provider store={store}>
				<BrowserRouter>
					<div>
						<Route path='/' component={Layout} />
						
					</div>
				</BrowserRouter>
			</Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js